// Thunks relacionados con puertas
import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/api";

/**
 * 📝 PUERTA - Obtener todas las puertas de un evento
 */
export const getPuertasPorEventoId = createAsyncThunk(
  "puerta/getPuertasPorEventoId",
  async ({ idEvento, uidEmpresa }, { rejectWithValue }) => {
    try {
      const { data } = await api.get(`/puertas/evento/${idEvento}`, {
        params: {
          uidEmpresa,
        },
        headers: {
          "Content-Type": "application/json",
        },
      });

      return data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.response?.data || "Error al obtener puertas del evento"
      );
    }
  }
);

/**
 * 📝 PUERTA - Crear nueva puerta
 */
export const crearPuerta = createAsyncThunk(
  "puerta/crearPuerta",
  async ({ puertaData }, { rejectWithValue }) => {
    try {
      const response = await api.post(`/puertas`, puertaData, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.response?.data || "Error al crear puerta"
      );
    }
  }
);

/**
 * 📝 PUERTA - Habilitar/Deshabilitar puerta
 */
export const toggleHabilitarPuerta = createAsyncThunk(
  "puerta/toggleHabilitarPuerta",
  async ({ uid, habilitado, uidEmpresa }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/puertas/${uid}/toggle-habilitado`,
        {
          habilitado,
          uidEmpresa,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.response?.data || "Error al cambiar estado de la puerta"
      );
    }
  }
);

/**
 * 📝 PUERTA - Extender tiempo de validación del código de activación
 */
export const extenderTiempoPuerta = createAsyncThunk(
  "puerta/extenderTiempoPuerta",
  async ({ uid, uidEmpresa }, { rejectWithValue }) => {
    try {
      const response = await api.put(
        `/puertas/${uid}/extender-tiempo`,
        {
          uidEmpresa,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || err.response?.data || "Error al extender tiempo de la puerta"
      );
    }
  }
);
